<template>
    <div id="woInvoiceList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Work Order Invoice List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <template v-if="canSend">
                            <a v-if="sendInvButton" href="javascript:void(0)" class="btn btn-secondary" v-on:click="sendInvoices()">
                                Send Invoice
                            </a>
                        </template>
                    </div>
                    <div  class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <a href="javascript:void(0)" class="" v-on:click="exportCheck()">Export</a> </li>
                                <li v-if="canSend"><a v-if="sendInvButton" href="javascript:void(0)" class="" v-on:click="sendInvoices()">Send Invoice</a></li>
                            </ul>
                        </div>
                    </div>    
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content wo-invoice-list">
                        <data-table-filter-config :moduleName="'woInvoiceList'" ref="woInvoiceFilter" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="batchProcess1" class="alert-success p-2">Current batch {{batchNum1}} is processing please wait!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'woInvoiceList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                mode="remote"
                                ref="woInvoiceList"
                                title="Work Order Invoice"
                                @on-page-change="onPageChange"
                                @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-selected-rows-change="selectionChanged"
                                :totalRows="totalRecords"
                                :columns="userColumns"
                                @on-select-all="onSelectAll"
                                :rows="rows"
                                :isLoading=false
                                :paginationOptions="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false

                                }"
                                :select-options="{
                                    enabled: invoice_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                                :search-options="{
                                    enabled: false,
                                }"
                                :sort-options="{
                                    enabled: true,
                                }"
                            >
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <template v-if="canUpdate">
                                            <template v-if="props.row.inv_status != undefined && props.row.inv_status.toLowerCase() == 'draft'">
                                                <template v-if="props.row.origin == 'manual' && props.row.invoice_type_code == 'WO' && props.row.enrich_id == null">
                                                    <router-link  title="Edit Work Order Invoice" class="fp-edit" v-bind:to="{name: 'WorkOrderInvoiceEdit',params:{id:props.row.id,from:'woInvList'}}"></router-link>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                    <div v-else-if="props.column.field == 'invoice_number' && canView">
                                        <template v-if="(props.row.origin == 'manual' || props.row.origin == 'system') && props.row.invoice_type_code == 'WO'">
                                            <router-link  title="View Work Order Invoice" class="color-blue" v-bind:to="{name: 'WorkOrderSalesInvoiceView',params:{id:props.row.id,from:'woInvList'}}">{{props.row.invoice_number}}</router-link>
                                        </template>
                                        <template v-else>
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </template>
                                    </div>
                                    <div v-else-if="props.column.field == 'work_order_no' && canViewWo">
                                        <template v-if="props.row.work_order_id != undefined && props.row.work_order_id != null && props.row.work_order_id != ''">
                                            <template v-if="props.row.work_order_no != undefined && props.row.work_order_no != null && props.row.work_order_no != ''">
                                                <router-link title="View Work Order" class="color-blue" v-bind:to="{name: 'WorkOrderView',params:{id:props.row.work_order_id},query:{fromUrl:fromUrl}}">{{props.row.work_order_no}}</router-link>
                                            </template>
                                            <template v-else>
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </template>    
                                        </template>
                                        <template v-else>
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </template>        
                                    </div>    
                                    <div v-else>
                                        <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                    </div>    
                                </div>
                            </template>
                            <div slot="selected-row-actions">
                                <button v-if="canDelete && showDeleteBtn" id="deleteInvoiceBtn" v-on:click.prevent="invoiceDelete" class="btn btn-danger">Delete</button>
                            </div>
                            </vue-good-table>                        
                            <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>    
                    </div>
                </div>            
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';
import EventBus from "./event-bus";


import VueSSE from 'vue-sse'
Vue.use(VueSSE);


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
let msgServer
export default {
    name: "WorkOrderInvoiceList",
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        invoice_value:true,
        permissions: [],
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                html: true,
                sortable: false,

            },
            {
                label: "#Invoice",
                field: "invoice_number",
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "#WO",
                field: "work_order_no",
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "WO", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
                {
                label: "Source",
                field: "inv_type",
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Source", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Customer",
                field: "customer",
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customers", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Customer Emails",
                field: "customer_emails",
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                html: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customers Emails", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: "Invoice Amount",
                field: "amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Invoice Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Open Invoice Amount",
                field: "current_open_inv_amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Open Invoice Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Applied Payment",
                field: "applied_payment",
                fpFieldType:"text",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Applied Payment", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Status",
                field: "inv_status",
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                // type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ["Draft", "Billed","Sent","Paid"], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Action By",
                field: "action_by",
                hidden:false,
                filterable: true,
                fpFieldType:"text",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Action By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Invoice Date",
                field: "invoice_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        cantAccessPage:"",
        canView:false,
        canDelete:false,
        showDeleteBtn:false,
        canUpdate:false,
        pageKey:"_invoice_list_",
        action:"list",
        batchProcess:0,
        batchNum:"",
        batchError:false,
        batchErrorMsg:"",
        batchProcess1:false,
        batchNum1:"",
        batchId:0,
        canSend:false,
        sendInvButton:false,
        canViewWo:false,
        fromUrl:""
    }),
    metaInfo () {
        return {
            title: "Work Order Invoice List | " +process.env.COPYRIGHT_NAME
        }
    },
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_invoice') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'view_invoice') {
                    self.canView = true;
                }
                if(permissions.name == 'delete_invoice') {
                    self.canDelete = true;
                }
                if(permissions.name == 'add_invoice') {
                    self.canUpdate = true;
                }
                if(permissions.name == 'send_invoice') {
                    self.canSend = true;
                }
                if(permissions.name == 'view_work_order') {
                    self.canViewWo = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },

    },
    created : function () {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.fromUrl = btoa(window.location.pathname);
    },
    beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.woInvoiceList.unselectAllInternal();
        },
        exportCheck: function() {
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['woInvoiceList'].selectedRows;
            count = data.length;
            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }
            this.exportReports(actionFlag);
        },
        checkBatchStatus:function(){
            var self =  this;

            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.batchProcess1 = false;
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.batchProcess1 = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
        loadList: function() {

            var self = this;
            var date = new Date();
            var offset = date.getTimezoneOffset();
            var selectedCust;
            if(self.action == 'sendInvoice') {
                var rowData = self.$refs['woInvoiceList'].selectedRows;

                selectedCust = rowData;
            }else if(self.action == 'deleteInvoice'){
                var rowData = self.$refs['woInvoiceList'].selectedRows;
                var invIdArr = [];
                for (var i = 0; i < rowData.length; i++) {
                    invIdArr.push(this.$refs['woInvoiceList'].selectedRows[i].id)
                }
                selectedCust = invIdArr;
            }
            var selectedRows = [];

            //because on first load list not initialize
            var data = self.$refs['woInvoiceList'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(self.$refs['woInvoiceList'].selectedRows[i].id)
            }

            self.loading = true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/list",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort: this.serverParams.sort,
                    offset:offset,
                    paymentId:this.$route.query.paymentId,
                    all:self.serverParams.selectedAll,
                    flag: self.action,
                    id : selectedCust,
                    selectedRows:selectedRows,
                    subSystemFlag:self.subSystemFlag,
                    listType:"work_order"

                },
                success: function(data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue") {
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {
                                if ( self.action == "export" ) {
                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";
                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                } else {
                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                            self.loadList();
                        }else if(self.action == 'deleteInvoice'){
                            self.action = "list";
                            self.$refs.woInvoiceFilter.clearSelectAll();
                            EventBus.$emit('clear-all-flags', false);
                            //message with invoice number if invoice not deleted
                            if (data.content.invoices != undefined && data.content.invoices != null) {
                                if (data.content.invoices != "") {
                                    self.$swal('',data.content.invoices,'info');
                                }
                            }
                            self.loadList();
                            return;
                        }else if(self.action=='sendInvoice') {
                            self.action = "list";

                            self.$refs.woInvoiceFilter.clearSelectAll();
                            self.$swal('', 'Invoices Sent', 'success');
                            EventBus.$emit('clear-all-flags', false);
                            self.batchId = data.batch;
                            self.batchNum1 = data.batchNumber;
                            self.batchProcess1 = true;
                            self.checkBatchStatus();
                            self.loadList();
                            return;
                        }else{
                            if(data.content.row != undefined) {
                                self.rows = data.content.row;
                            }
                            if(data.content.totalRecords == 0){
                                self.rows = [];
                            }
                            self.totalRecords = data.content.totalRecords;
                        }
                        
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'wo-invoice-list');
                }
            });
        },
        selectionChanged(param) {

            var self = this;
            var rowData = self.$refs['woInvoiceList'].selectedRows;
            var selectedStatusArr = [];
            if(rowData.length > 0){

                for(var i = 0;i<rowData.length;i++){
                    selectedStatusArr.push(rowData[i].inv_status.toLowerCase());
                }

                //check all values in array are equal or not
                const allEqual = arr => arr.every( v => v === arr[0] );
                var draftFound = allEqual(selectedStatusArr);

                if (draftFound && selectedStatusArr.includes("draft")) {
                    self.showDeleteBtn = true;
                    self.sendInvButton = true;
                }else{
                    self.sendInvButton = true;
                    self.showDeleteBtn = false;
                    if(selectedStatusArr.includes("draft")){
                        self.showDeleteBtn = true;
                    }
                }
            }else{
                self.showDeleteBtn = false;
                self.sendInvButton = false;
            }
            if(param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
            } else {
                EventBus.$emit('clear-all-flags', false);
            }


            self.serverParams.selectedAll = false;
        },
        invoiceDelete() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Work Order Invoice?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "deleteInvoice";
                    self.loadList();

                } else {

                }
            });
        },
        sendInvoices() {
            var self = this;

            self.action="sendInvoice"
            self.loadList();
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/WorkOrderInvoiceList.vue